module.exports = __webpack_public_path__ + "img/096_thumbnail.2e8ee3d7.jpg";